import { Injectable } from '@angular/core';
import {
  NewReviewReceivedDataModel,
  UserNotificationData,
  UserNotificationModel,
  UserNotificationType,
} from '@rma/dashboard/notification-bell/private/api-user-notifications';
import { NotificationItemContent } from './notification-item-content';
import { NotificationMetaData } from './notification-meta-data';
import { metaDataMap } from './notification-meta-data-helper';

@Injectable({
  providedIn: 'root',
})
export class NotificationContentService {
  public getNotificationContent(notification: UserNotificationModel): NotificationItemContent {
    const type = notification.userNotificationType;

    // This is a hack until we return review code into the actual payload
    if (
      type === UserNotificationType.NewReviewReceived &&
      // SAFETY(legacy): unreviewed, pre-dates this rule.
      typeof (notification.data as NewReviewReceivedDataModel)?.ReviewCode === 'undefined'
    ) {
      notification.data = {
        ...notification.data,
        ReviewCode: notification.identifier['ReviewCode'],
      };
    }

    const metadata = this.getNotificationMetaData(type, notification.data);
    return {
      titleLanguageKey: `message.${type}.title`,
      ctaLanguageKey: `message.${type}.cta`,
      languageMergeData: metadata.mergeData,
      agentRoute: metadata.agentRoute,
      agencyRoute: metadata.agencyRoute,
      redirectUrl: metadata.redirectUrl,
    };
  }

  private getNotificationMetaData(notificationType: UserNotificationType, data: UserNotificationData): NotificationMetaData {
    return metaDataMap[notificationType](data);
  }
}
